import translations from "../i18n/translations";
import { getStoredLanguage } from "../context/I18nContext";

const DEFAULT_LANG = "ar";

function resolveLanguage(lang) {
  if (lang && translations[lang]) return lang;
  if (typeof window !== "undefined") {
    const stored = getStoredLanguage();
    if (stored && translations[stored]) return stored;
  }
  return DEFAULT_LANG;
}

export function withLangHeaders(headers = {}) {
  const lang = resolveLanguage();
  return { ...headers, "Accept-Language": lang };
}

export function withLangParams(params = {}) {
  const lang = resolveLanguage();
  return { ...params, lang };
}

// Pick localized value from record using common patterns
export function localizeField(record, field, lang) {
  const targetLang = resolveLanguage(lang);
  if (!record || !field) return undefined;
  const translationObject = record.translations || record.localized;
  if (translationObject && translationObject[targetLang] && translationObject[targetLang][field] != null) {
    return translationObject[targetLang][field];
  }
  const directKey = `${field}_${targetLang}`;
  if (record[directKey] != null) return record[directKey];
  return record[field];
}

export function getDirFor(lang) {
  const targetLang = resolveLanguage(lang);
  return translations[targetLang]?.meta?.dir || "ltr";
}
